import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"
import styles from "./AddRegisteredPatientPage.module.css"
import AddRegisteredPatient from "@components/AddRegisteredPatientPage/AddRegisteredPatient"

function AddRegisteredPatientPage() {
  return (
    <NavigationsPage>
      <PageWrapper className={styles.manageAppointmentPage}>
        <AddRegisteredPatient />
      </PageWrapper>
    </NavigationsPage>
  )
}

export default AddRegisteredPatientPage
